module.exports = __webpack_public_path__ + "img/fh_code_2.d70b6907.png";